import styled from 'styled-components';
import { rem } from 'polished';
import Modal from '../../../core/Modal';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';

export const AvatarModal = styled(Modal)`
  > div {
    margin: 0 auto;
    padding: 0;
    ${mediaqueries.greaterThan('tablet')`
      padding: 3.125rem ${rem('35px')};
      margin: auto;
  `};
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .avatar-image {
    max-width: 100%;
    max-height: 100%;

    ${mediaqueries.greaterThan('tablet')`    
      max-height: ${rem('392px')};
   `};

    ${mediaqueries.greaterThan('desktop')`
      max-width: ${rem('728px')};    
   `};
  }

  .button-back {
    position: absolute;
    top: ${rem('10px')};
    left: ${rem('-21px')};
  }

  ${mediaqueries.greaterThan('tablet')`
     .button-back {
        position: absolute;
        top: ${rem('25px')};
        left: ${rem('20px')};
      }
  `};

  ${mediaqueries.greaterThan('desktop')`
     flex-direction: row;
     height: calc(100vh - ${rem('232px')});
  `};
`;

export const BoxImg = styled.div`
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  max-width: 100%;
  width: 100%;
  display: inline-block;

  ${mediaqueries.greaterThan('tablet')`
    width: auto;
    
  `};
`;

export const Box = styled.div`
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const Scope = styled.div`
  position: relative;
  cursor: move;
  box-shadow: 0 0 0 20000px rgba(0, 0, 0, 0.5);
  width: 200px;
  height: 200px;
  border-radius: 100px;
  display: inline-flex;
`;

export const StyledWrapperBox = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  width: 100%;
  padding: ${rem('47px')} 0;
  text-align: center;
  margin-top: 5rem;
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    align-items: center;
  `};
`;
